import { Stack, Typography, CircularProgress } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { theme } from "themes/default/theme"

export default function LoaderModal() {
  const { t } = useTranslation()
  return (
    <Stack
      className="loader-modal"
      spacing={2}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        minWidth: 400,
        minHeight: 180,
      }}
    >
      <CircularProgress
        sx={{
          color: theme.palette.primary.main,
          width: 50,
          height: 50,
        }}
        size={"large"}
      />
      <Typography variant="span" fontSize={20}>
        {t("loading")}
      </Typography>
    </Stack>
  )
}
